import axiosInstance from "./baseUrl";

export const getAllOrders = async (parameters: any) => {
  const response = await axiosInstance.get("/v1/order/admin/orders", {
    params: parameters,
  });
  return response.data;
};

export const getOrderSummary = async () => {
  const response = await axiosInstance.get("/v1/order/summary");
  return response.data;
};

export const getSingleDispute = async (disputeId: string) => {
  const response = await axiosInstance.get(`/v1/order/dispute/${disputeId}`);
  return response.data;
};

export const getOrderByAdmin = async (orderId: any) => {
  const response = await axiosInstance.get(`/v1/order/${orderId}`);
  return response.data;
};

export const updateDropOffDetails = async (
  contractId: string,
  dropOfDetails: any,
) => {
  const response = await axiosInstance.put(
    `/v1/order/contract/${contractId}/dispatch-order`,
    dropOfDetails,
  );
  return response.data;
};

export const updateBulkDropOffDetails = async (
  agentId: string,
  dropOfDetails: any,
) => {
  const response = await axiosInstance.post(
    `/v1/order/bulk-update-location`,
    dropOfDetails,
  );
  return response.data;
};

export const updateDropOffLocation = async (
  orderId: string,
  locationDetails: any,
) => {
  const response = await axiosInstance.put(
    `/v1/order/${orderId}/update-location`,
    locationDetails,
  );
  return response.data;
};

export const updateDispatchStatus = async (dispatchDetails: any) => {
  const response = await axiosInstance.put(
    `/v1/order/update-order-location`,
    dispatchDetails,
  );
  return response.data;
};

export const getAllDisputeOrders = async (parameters: any) => {
  const response = await axiosInstance.get(
    "/v1/order/list_desputes-for-orders",
    {
      params: parameters,
    },
  );
  return response.data;
};

export const getAllExecutedOrders = async (parameters: any) => {
  const response = await axiosInstance.get(
    "/v1/order/orders_that_was_acted_on",
    {
      params: parameters,
    },
  );
  return response.data;
};
export const getOrdersInTransit = async (
  parameters: any,
  courierOfficeId: string | number,
) => {
  const response = await axiosInstance.get(
    `/v1/order/in-transit/${courierOfficeId}`,
    {
      params: parameters,
    },
  );
  return response.data;
};

export const getAllReturnedOrders = async (parameters: any) => {
  const response = await axiosInstance.get("/v1/order/return-orders", {
    params: parameters,
  });
  return response.data;
};

export const getDisputeReasons = async (parameters?: any) => {
  const response = await axiosInstance.get("/v1/order/reasons", {
    params: parameters,
  });
  return response.data;
};

export const getDisputeReasonById = async (id: any) => {
  const response = await axiosInstance.get(`/v1/order/reasons/${id}`);
  return response.data;
};

export const reviewDispute = async (parameters: any) => {
  const response = await axiosInstance.put(
    `/v1/order/dispute/review`,
    parameters,
  );
  return response.data;
};

export const callFinalDecision = async (parameters: any) => {
  const response = await axiosInstance.put(
    `/v1/order/dispute/final-decision`,
    parameters,
  );
  return response.data;
};

export const completeCourierPayment = async (parameters: any) => {
  const response = await axiosInstance.put(
    `/v1/order/courier-fee/payment-status`,
    parameters,
  );
  return response.data;
};
